import { useAnimate } from "framer-motion";
import { forwardRef, useEffect, useRef, useState } from "react";
import Banner from "../../../components/Banner";
import { getPublicUrl, mergeRefs } from "../../../helpers/helper_functions";

import "../Home.css";
import "./AnimalsCanHero.css";

var AnimalsCanDoArray = [
  "can love",
  "can think",
  "can play",
  "can cry",
  "can suffer",
  "are just like us.",
];

const AnimalVideo = ({ videoWatchedCount, setVideoWatchedCount }) => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);

  const handleCloseVideo = () => {
    // Mark video as watched and close it
    setVideoWatchedCount(videoWatchedCount + 1);
  };

  const handleOutsideClick = (e) => {
    // If clicking on the container (outside the video player), close the video
    if (e.target === containerRef.current) {
      handleCloseVideo();
    }
  };

  useEffect(() => {
    // Handle video end
    videoRef.current.addEventListener("ended", () => {
      setVideoWatchedCount(videoWatchedCount + 1);
    });

    // Add escape key listener
    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        handleCloseVideo();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [videoWatchedCount, setVideoWatchedCount]);

  return (
    <div className="video" ref={containerRef} onClick={handleOutsideClick}>
      <div className="video-wrapper">
        <button className="video-close-btn" onClick={handleCloseVideo}>
          ×
        </button>
        <video
          id="AnimalsCanHeroBannerVideo"
          ref={videoRef}
          autoPlay
          muted
          controls
          onClick={(e) => e.stopPropagation()}
        >
          <source src={getPublicUrl("assets/Home/animalsarelikeus.webm")} />
          video not supported
        </video>
      </div>
    </div>
  );
};

// click button
// animals are just like us text splits
// video grows from the middle to full size

// on video terminate
// video shrinks
// text rejoins to say animals are just like us.
// text flips to say "go vegan"
// button text wipes to say rewatch

const AnimalsCanHero = forwardRef(({}, ref) => {
  var [scope, animate] = useAnimate();
  const [videoMode, setVideoMode] = useState(false);
  const [videoWatchedCount, setVideoWatchedCount] = useState(0);

  const triggerVideo = () => {
    setVideoMode(true);
  };

  const wasVideoWatched = () => {
    return videoWatchedCount > 0;
  };

  useEffect(() => {
    if (videoMode) {
      const textGoesUp = wasVideoWatched()
        ? ".textfirsthalf"
        : ".textsecondhalf";
      const textGoesDown = wasVideoWatched()
        ? ".textsecondhalf"
        : ".textfirsthalf";

      console.log("Video mode true");
      animate([
        ["#watch-video", { opacity: [1, 0] }, { duration: 1, at: 0 }],
        [
          textGoesDown,
          { transform: ["translate(0%, 0%)", "translate(0%, -75%)"] },
          { duration: 1.75, at: 1 },
        ],
        [
          textGoesUp,
          { transform: ["translate(0%, 0%)", "translate(0%, 75%)"] },
          { duration: 1.75, at: "<" },
        ],
        [
          ".main_image, .darkenable",
          {
            filter: [
              "brightness(100%) grayscale(0%)",
              "brightness(25%) grayscale(80%)",
            ],
          },
          { duration: 0.75, at: 1.25 },
        ],
        [".video", { opacity: [0, 1] }, { duration: 1.65, at: 1.85 }],
        [
          ".video",
          { transform: ["translate(0%, -2%)", "translate(0%, 0%)"] },
          { duration: 1.25, at: 1.85 },
        ],
      ]);
    }
  }, [videoMode]);

  useEffect(() => {
    if (videoMode && wasVideoWatched()) {
      console.log("Video mode true");
      animate([
        [".video", { opacity: [1, 0] }, { duration: 1.65 }],
        [".video", { transform: ["translate(0%, 2%)"] }, { duration: 1.25 }],
        [
          ".main_image, .darkenable",
          {
            filter: ["brightness(100%) grayscale(0%)"],
          },
          { duration: 0.75, at: 1.25 },
        ],
        [
          ".textfirsthalf",
          { transform: ["translate(0%, 0%)"] },
          { duration: 1.75, at: 1 },
        ],
        [
          ".textsecondhalf",
          { transform: ["translate(0%, 0%)"] },
          { duration: 1.75, at: "<" },
        ],
        ["#watch-video", { opacity: [0, 1] }, { duration: 1, at: 2.75 }],
      ]);

      setVideoMode(false);
    }
  }, [videoWatchedCount]);

  return (
    <Banner
      ref={mergeRefs(ref, scope)}
      className="banner2"
      background_image={getPublicUrl("assets/Home/miranda_bby_pig.jpg")}
      mobile_background_image={getPublicUrl("assets/Home/miranda_bby_pig-mobile.jpg")}
      background_image_details={"no-repeat 80% 80%"}
    >
      {" "}
      <div id="animals-are-quote" className="darkenable">
        <span className="textfirsthalf">
          {wasVideoWatched() ? "let's go" : "animals are"}
        </span>
        &nbsp;
        <span className="textsecondhalf">
          {wasVideoWatched() ? "vegan" : "just like us."}
        </span>
      </div>
      <div id="watch-video" className="darkenable">
        <button id="watch-video-button" onClick={triggerVideo}>
          {wasVideoWatched() ? "REWATCH" : "WATCH"}
        </button>
      </div>
      {videoMode ? (
        <AnimalVideo
          videoWatchedCount={videoWatchedCount}
          setVideoWatchedCount={setVideoWatchedCount}
        />
      ) : null}
    </Banner>
  );
});

export default AnimalsCanHero;

{
  /* <DynamicText
            phrase={"can love"}
            duration={1000}
            untype={true}
          />{" "} */
}
